import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '@loup-transload-ui-app/common-services';

@Pipe({ name: 'translate', standalone: true })

export class TranslatePipe implements PipeTransform {
  constructor(private translationService: TranslationService) {}

  transform(key: string, params?: Record<string, string>): string {
    return this.translationService.translate(key, params);
  }
}
/** <span>{{ 'I18N_LABEL.24_HOUR_FORMAT' | translate }}</span> */ 